<template>
  <div class="hiddenScrollbar detail">
    <div class="Spot-Info box">
      <w-image :imageUrl="community.imageUrl" :pictures="community.pictures" ref="wImage" @click.native="showImages"></w-image>
      <div class="Right">
        <!--  -->
        <div class="Right-Top">
          <div class="Right-One Right-Padding">
            <span v-if="community.score">{{ community.score }}<span style="font-size: 15px">分</span></span>
            <span style="font-size: 14px;" v-else>暂无评分</span>
          </div>
          <!-- 景点 -->
          <div class="Right-One-Spot Right-Padding">
            <p>使用率：{{community.otherResourceData.usageRate}}%</p>
            <p>排名：{{ community.otherResourceData.ranking }}</p>
          </div>
          <div class="Right-Two Right-Padding">
            <el-rate
              v-if="community.star"
              v-model="community.star"
              :max="community.star"
              disabled
              >
            </el-rate>
            <i v-if="community.addressCn" class="el-icon-location-outline van-icon" />
            <span class="ellipsis">{{ community.addressCn }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 景点售票信息 -->
    <div v-if="community.otherResourceData.openingTime" class="Traffic box box-kuang">
      <p style="display: flex;"><svg-icon class="icon-title" iconClass="jingdian"></svg-icon>开园时间</p>
      <p class="box-content" style="color: #323232;">{{ community.otherResourceData.openingTime }}</p>
    </div>

    <div v-if="community.introduction" class="Introduce box box-kuang">
      <p style="display: flex;"><svg-icon class="icon-title" iconClass="jianjie"></svg-icon>简介</p>
      <p class="box-content" style="color: #323232;">{{ community.introduction }}</p>
    </div>

    <div v-if="community.stockListResults" class="Price box box-kuang">
      <p style="display: flex;"><svg-icon class="icon-title" iconClass="jiage"></svg-icon>价格详情</p>
      <div class="Price-Box">
        <div class="Price-Top">
          <span :class = "spanCheck == 1 ? 'active-span' : ''" @click="setSpanCheck(1)"><svg-icon class="icon-title" iconClass="mengpiao"></svg-icon>门票</span>
          <span :class = "spanCheck == 2 ? 'active-span' : ''" @click="setSpanCheck(2)">年季卡</span>
          <span :class = "spanCheck == 3 ? 'active-span' : ''" @click="setSpanCheck(3)">特色体验项</span>
          <span :class = "spanCheck == 4 ? 'active-span' : ''" @click="setSpanCheck(4)">门票+项目组</span>
        </div>
        <p class="Price-Hang box-content" v-for="(item,index) in community.stockListResults" :key="index">
          <span>{{ item.productNameCn }}</span>
          <el-tag type="success" v-if="item.cancelType == 1">不可取消</el-tag>
          <el-tag type="warning" v-else>有条件退</el-tag>
        </p>
      </div>
    </div>
    <!-- 交通信息 -->
    <div v-if="community.otherResourceData.arrivalTraffic" class="Traffic box box-kuang">
      <p style="display: flex;"><svg-icon class="icon-title" iconClass="jiaotong"></svg-icon>周边交通</p>
      <p class="box-content" style="color: #323232;" v-html="community.otherResourceData.arrivalTraffic"></p>
    </div>

    <!-- 官网及联系电话 -->
    <div v-if="community.otherResourceData.tips" class="Traffic box box-kuang">
      <p style="display: flex;"><svg-icon class="icon-title" iconClass="guanwang"></svg-icon>官网及联系电话</p>
      <p v-if="community.website" class="box-content" style="color: #323232;">web：{{ community.website }}</p>
      <p v-if="community.phone" class="box-content" style="color: #323232;">phone：{{ community.phone }}</p>
    </div>

    <!-- 温馨提示 -->
    <div v-if="community.otherResourceData.tips" class="Traffic box box-kuang">
      <p style="display: flex;"><svg-icon class="icon-title" iconClass="jiage"></svg-icon>温馨提示</p>
      <p class="box-content" style="color: #323232;">{{ community.otherResourceData.tips }}</p>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { dateUtil } from "@/mixins/dateUtil";
export default {
  name:  '',
  components: {
    
  },
  props:['community','checkBudgets'],
  mixins: [dateUtil],
  // 定义属性
  data() {
    return {
      noImage: require('@/assets/png/noImage.png'),
      spanCheck: 1
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    setSpanCheck(spanCheck) {
      this.spanCheck = spanCheck
    },
    showImages() {
            this.$refs.wImage.show()
        },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.box {
  box-shadow: 2px 2px 5px #e5e4e4;
}
.detail {
    overflow-y: scroll;
    position: absolute;
    top: 60px;
    bottom: 0;
    .Price {
      background: #fff;
      border: 1px solid #e5e4e4;
      margin: 20px;
      display: flex;
      padding: 10px;
      display: flex;
      flex-direction: column;
      >p:nth-child(1) {
        font-weight: 700;
      }
    }
    .Introduce {
      background: #fff;
      border: 1px solid #e5e4e4;
      margin: 20px;
      display: flex;
      padding: 10px;
      display: flex;
      flex-direction: column;
      >p:nth-child(1) {
        font-weight: 700;
      }
      >p:nth-child(2) {
        text-align: justify;
        text-justify:distribute-all-lines; // 这行必加，兼容ie浏览器
        text-align-last: left;
      }
    }
    .Spot-Info {
      background: #fff;
      border: 1px solid #e5e4e4;
      margin: 20px;
      height: 150px;
      display: flex;
      .Right {
        padding: 10px;
        position: relative;
        width: -webkit-fill-available;
        .Right-One {
          font-size: 24px;
          color: #646464;
          font-weight: 200;
          display: flex;
          /deep/ .el-icon-star-on {
            color: #db4e1a !important;
            font-size: 18px;
          }
          /deep/ .el-rate {
            height: 100%;
            display: flex;
            align-items: center;
            padding-left: 5px;
          }
          >span {
            display: flex;
            align-items: center;
          }
          >p {
            font-size: 0.12rem;
            display: flex;
            align-self: center;
            margin-left: 8px;
          }
        }

        .Right-One-Spot {
           color: #646464;
           font-weight: 200;
           display: flex;
           >p {
            font-size: 0.12rem;
            display: flex;
            align-self: center;
            margin-right: 5px;
           }
        }
        .Right-Two {
          font-weight: 200;
        }

        .Right-End {
          display: flex;
          justify-content: space-between;
          margin-left: 12px;
          transform: scale(0.75);
          position: absolute;
          right: -20px;
          top: 0px;
          >span {
            margin-right: 5px;
            display: flex;
            color: #02A0C6;
            font-size: 0.12rem;
            font-weight: 400;
            &:hover {
              cursor: pointer;
              transform: scale(0.9);
            }
          }
        }
      }
    }
  }

  .icon-class {
    height: 12px;
    width: 12px;
    display: flex;
    align-self: center;
    margin-right: 2px;
    color: blue;
  }

  .icon-title {
    margin-right: 8px;
    display: flex;
    align-self: center;
    height: 18px;
    width: 18px;
  }

  .Right-Padding {
    padding-top: 2px;
  }

  .box-kuang {
    background: #fff;
    border: 1px solid #e5e4e4;
    margin: 20px;
    display: flex;
    padding: 10px;
    display: flex;
    flex-direction: column;
    >p:nth-child(1) {
      font-weight: 700;
      align-items: center; 
      padding-bottom: 7px;
    }
  }
  // p标签内每一行的文本下划线设置
  .box-content {
    display: inline-block;
    position: relative;
    text-decoration: underline dashed;
    text-decoration-color: #e5e5e5;
    text-underline-offset: 4.8px;
    line-height: 1.6;
  }

  .Right-Top {
    margin-top: 10px;
  }

  .Price-Top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    >span {
      border: 1px solid #02A0C6;
      flex: 1;
      text-align: center;
      line-height: 1.5;
      margin-right: -1px;
      display: flex;
      justify-content: center;
      &:hover {
        cursor: pointer;
      }
    }
    .Price-Hang {
      top: 15px;
    }

    .active-span {
      color: white;
      background-color: #02A0C6;
    }
  }
  
</style>